const BreadcrumbItem = () => {
  return [
    {
      title: `Dashboard`,
      path: `/dashboard`,
      isActive: false
    },
    {
      title: `Ledger`,
      path: ``,
      isActive: true
    }
  ];
};

export default BreadcrumbItem;
